/*
 * Allow select lists with a [data-options-triggers] attribute to run
 * special commands when selecting certain options. Currently we only have
 * [data-checkbox-on] and [data-checkbox-off]. If [data-allow-manual-override]
 * is set on the select list and the item has already been touched by the user
 * the action is ignored.
 *
 */

$("body").on("change", "select[data-options-triggers]", function () {

    let select = $(this);

    // Get the selected option's action target if it has one

    let option = select.find(':selected');
    let actionTarget = option.data("action-target");

    let actionTargetElement = document.querySelector("[data-action-target-id=" + actionTarget + "]");

    if (!actionTargetElement) {
        return false; // The target doesn't exist
    }

    // Check if manual override is allowed and if so,
    // if the item has already been touched by the user, ignore the action
    if (select.data("allow-manual-override") && actionTargetElement.getAttribute("data-touched")) {
        return;
    }

    // Trigger actions

    switch (option.data("action")) {
        case "checkbox-on":
            actionTargetElement.checked = true;
            break;
        case "checkbox-off":
            actionTargetElement.checked = false
            break;
    }

})

// Add a data-touched attribute to any input clicked by a user
$("body").on("click", "input", function () {
    this.setAttribute("data-touched", true);
})
